module.exports = __webpack_public_path__ + "img/32.69a20a4f.jpg";